<template>
  <v-flex
    ma-2
    xs12
    px-2
  >
    <v-text-field
      v-model="filterLocal"
      append-icon="search"
      class="item-list-filter pt-0"
      :placeholder="$t('poLineItemsFilter.filterPlaceholder')"
      clearable
      hide-details
      :disabled="disabled"
      @click:clear="clearFilter"
    />
  </v-flex>
</template>

<script>
export default {
  name: 'poLineItemsFilter',
  computed: {
    filterLocal: {
      get() {
        return this.filter;
      },
      set(val) {
        this.$emit('filter-changed', val);
      },
    },
  },
  methods: {
    clearFilter() {
      this.filter = null;
    },
  },
  props: {
    filter: String,
    disabled: Boolean,
  },
};
</script>

<i18n>
{
  "en": {
    "poLineItemsFilter": {
      "filterPlaceholder": "Enter Item #..."
    }
  }
}
</i18n>
